import permissionService from '@app/services/permissionService'
import { isNullable } from '@app/utils'

import { SAVE_ITEM_ROLES, SAVE_COMMENT_ROLES } from '../constants'

import type { UserDto } from '@app/api/routes/auth/dtos'

export const ableToSaveItem = (user?: UserDto): boolean => {
  if (isNullable(user) || isNullable(user?.roles)) return false

  return permissionService.hasOneOfRoles(user.roles, SAVE_ITEM_ROLES)
}

export const ableToSaveComment = (user?: UserDto): boolean => {
  if (isNullable(user) || isNullable(user?.roles)) return false

  return permissionService.hasOneOfRoles(user.roles, SAVE_COMMENT_ROLES)
}
